import React from 'react';
import { Typography } from '@mui/material';
import * as ViewSelectors from 'selectors/ViewSelectors';
import { OrderInfo, ProductApi } from 'common/types';
import { useTranslation } from 'services/localization';
import { getTranslation } from 'common/modules/translations';
import { useSelector } from 'react-redux';

interface Props {
	stockProducts: ProductApi[];
	rentalInfo: OrderInfo;
}
const RentalCardProducts = (props: Props) => {
	const { stockProducts, rentalInfo } = props;
	const { t } = useTranslation();
	const language = useSelector(ViewSelectors.lang);

	const MAX_AMOUNT_OF_PRODUCTS_PER_CARD = 3;

	const { stockProductIds } = rentalInfo;
	const totalAmountOfProducts = Object.values(rentalInfo.shopperIdsWithProducts).flat().length;

	const uniqueProducts = stockProducts.filter((stockProduct) =>
		stockProductIds.some((stockProductId) => stockProduct.id === stockProductId),
	);
	const productsToShow = uniqueProducts.slice(0, MAX_AMOUNT_OF_PRODUCTS_PER_CARD);
	const productsOverMax = uniqueProducts.length - MAX_AMOUNT_OF_PRODUCTS_PER_CARD;

	const renderRentalProductAmount = (totalAmountOfProducts: number, uniqueProductCount: number) => {
		const allUniqueProducts = totalAmountOfProducts === uniqueProductCount;
		return (
			<Typography variant={'body1'} color="textSecondary">
				{totalAmountOfProducts +
					' ' +
					(totalAmountOfProducts > 1
						? allUniqueProducts
							? t('rentalCard.products', 'products')
							: t('rentalCard.productsIncluding', 'products, incl.')
						: t('rentalCard.product', 'product'))}
			</Typography>
		);
	};

	return (
		<>
			{renderRentalProductAmount(totalAmountOfProducts, uniqueProducts.length)}
			{productsToShow.map((orderProduct) => {
				return (
					<div key={orderProduct.id}>
						<Typography variant="body2">{getTranslation(orderProduct.name, language)}</Typography>
					</div>
				);
			})}
			{productsOverMax > 0 && (
				<Typography variant="caption">{`+${productsOverMax} ${t(
					'rentalCard.moreProducts1',
					'more products',
				)}`}</Typography>
			)}
		</>
	);
};

export default RentalCardProducts;
